// QRGenerator.jsx - Updated to use the new modular wizard
import React from 'react';
import QRWizard from '../components/QRWizard';

const QRGenerator = () => {
  return <QRWizard />;
};

export default QRGenerator;
